import React,{useEffect, useState} from 'react'
import ClientMenu from './ClientMenu'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { useLocation, useNavigate } from 'react-router-dom';
import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
import { IconButton } from '@mui/material'
import {BsArrowRepeat} from 'react-icons/bs';
import { DeleteClientService, FilterClientService } from '../../services/ClientService';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { Modal } from 'antd';
import toast from 'react-hot-toast';
import { DatePicker } from 'antd';
import { useSelector } from 'react-redux';

function ClientList() {

  const roles = useSelector(state=>state.Auth.roles)

  const [page,setpage] = useState(1)
  const [modal,setmodal] = useState(false)
  const [search,setsearch] = useState({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
  const [data,setdata] = useState({})  
  const [selecteddata,setselecteddata] = useState({})  

  const {pathname} = useLocation()
  const path = pathname?.split('/')[pathname?.split('/')?.length - 1]
  

  useEffect(()=>{
    getData()
  },[page,path])

  async function getData(){
    const response = await FilterClientService(page,search?.text,search?.from_date1,search?.to_date1,path)
    setdata(response?.data)
  }

  const navigate = useNavigate() 

  async function applyfilter(){
    const response = await FilterClientService(1,search?.text,search?.from_date1,search?.to_date1,path)
    setdata(response?.data)
  }

  async function resetfunc(){
    setpage(1)
    setsearch({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
    const response = await FilterClientService(1,'','','',path)
    setdata(response?.data)
  }  

  async function deleteData(){
    const response = await DeleteClientService(selecteddata?._id)
    if(response?.status === 200){
      getData()
      setmodal(false)
      toast.success("Deleted Successfully!")
    }
  }

  // console.log("search",search)

  return (
    <div className='flex pt-5 md:pt-0 flex-col md:flex-row'>
        <Modal className='absolute top-0  left-[40%]' width={300} footer={false} closable={false} open={modal}>
          <div>
            <h6 className='text-[13px] font-[700]'>Delete Data</h6>
            <h6 className='text-[12px] bg-slate-100 p-[4px]'>Are you sure want to delete the selected Data</h6>
             
            <div className='my-1'>
               <h6 className='text-[11px]'>Name : <span className='font-[700]'>{selecteddata?.name}</span></h6>
               <h6 className='text-[11px]'>Mobile : <span className='font-[700]'>{selecteddata?.mobile}</span></h6>
            </div> 

            <div className='flex items-center mt-2 border-t pt-2'>
               <ButtonOutlinedAutoWidth onClick={()=>setmodal(false)} btnName="Cancel" />
               <h6 className='w-[10px]'></h6>
               <ButtonFilledAutoWidth btnName="Save" onClick={deleteData} />
            </div>
          </div>

        </Modal>
        <ClientMenu />
        <div className='md:w-[85%] px-4 pt-2 md:pt-2'>
        <div className='flex flex-col  md:flex-row border-b pb-2 border-slate-200 w-[100%] md:items-center md:justify-between'>
          
          <div className='flex items-center justify-between'>
          <h6 className='font-[600] text-[14px] '>{'Total Client'} ({data?.pagination?.total})</h6>

          <div className='block md:hidden items-center '>
            <div className='hidden md:flex items-center  text-[12px] mr-2'>

            <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
            <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

            <div>
            <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

            </div>
            </div>
          </div>
          </div>
          
          <div className='mt-2 flex flex-col md:flex-row items-start md:items-center md:mt-0'>
           <div className='hidden md:flex items-center  text-[12px] mr-2'>

            <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
            <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

            <div>
            <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

            </div>
            </div>
            <div className='flex items-center'>
            <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.from_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,from_date:v,from_date1:v1})}} /> 

            <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.to_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,to_date:v,to_date1:v1})}} /> 

              
              <input id="search_text" placeholder='Search ...' type='text' value={search?.text}  onChange={(e)=>setsearch({...search,text:e.target.value})} className='border text-sm py-[4px] focus:ring-0  focus:outline-0 text-[13px]  w-28 px-1 rounded-md border-slate-300' />
            </div>
            <div className="mt-2 md:mt-0 md:ml-2 flex">
            <ButtonOutlinedAutoWidth onClick={()=>{setpage(1);applyfilter()}}  btnName="Add Filter" />

            <div className="ml-2">
            <ButtonFilledAutoWidth btnName="Add New" onClick={()=>navigate('create')}   />
            </div> 
          </div>
          </div> 
       </div>
       
       
        {data?.datas?.length === 0 &&
            <div className='grid place-items-center mt-20  items-center justify-center'>
            <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
            <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
            <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
          </div>
          }

          {data?.datas?.length > 0 &&
          <div className='max-h-[82vh]  mt-4 border-t   border-l border-r overflow-y-scroll'>
            <div className='sticky top-0 z-50 w-max md:w-[100%] flex  bg-white py-[-5px] border-b border-slate-200 relative'>
                <h6  className='top-0 bg-white z-50 text-[12px] w-[70px] min-w-[70px] md:w-[5%] md:min-w-[5%]  px-2 py-1 font-[600] text-slate-600 border-r flex items-center justify-center'>SL NO</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[140px] min-w-[140px] md:w-[12%] md:min-w-[12%]  px-2 py-1 font-[600] text-slate-600 border-r'>Client Name</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[90px] min-w-[90px] md:w-[10%] md:min-w-[10%]  px-2 py-1 font-[600] text-slate-600 border-r'>Mobile</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[180px] min-w-[180px] md:w-[15%] md:min-w-[15%]  px-2 py-1 font-[600] text-slate-600 border-r'>Email</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[138px] min-w-[138px] md:w-[12%] md:min-w-[12%] px-2 py-1 font-[600] text-slate-600 border-r'>Company Name</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[200px] min-w-[200px]  md:w-[15%] md:min-w-[15%] px-2 py-1 font-[600] text-slate-600 border-r'>Address</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[100px] min-w-[100px] md:w-[10%] md:min-w-[10%] px-2 py-1 font-[600] text-slate-600 border-r'>Type</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[200px] min-w-[200px] md:w-[15%] md:min-w-[15%] px-2 py-1 font-[600] text-slate-600 border-r'>Summary</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[90px] min-w-[90px] md:w-[6%] md:min-w-[6%] px-2 py-1 font-[600] text-slate-600'>Actions</h6>
            </div>
            {data?.datas?.map((d,i)=>(
            <div className='flex w-max md:w-[100%]  bg-white py-[-5px] border-b border-slate-200 relative'>
                <h6  className='bg-white  truncate z-50 text-[12px] w-[70px] min-w-[70px] md:w-[5%] md:min-w-[5%]  px-2 py-1 text-black border-r flex items-center justify-center'>{page == 1 ? i+1 : (data?.pagination?.limit * (page - 1)) + (i+1)}</h6>
                <h6 className='text-[12px] truncate w-[140px] min-w-[140px] md:w-[12%] md:min-w-[12%]  px-2 py-1 opacity-70  text-black border-r'>{d?.name}</h6>
                <h6 className='text-[12px] truncate w-[90px] min-w-[90px] md:w-[10%] md:min-w-[10%]  px-2 py-1  opacity-70 text-black border-r'>{d?.mobile}</h6>
                <h6 className='text-[12px] truncate w-[180px] min-w-[180px] md:w-[15%] md:min-w-[15%]  px-2 py-1 opacity-70  text-black border-r'>{d?.email}</h6>
                <h6 className='text-[12px] truncate w-[138px] min-w-[138px] md:w-[12%] md:min-w-[12%] px-2 py-1  opacity-70 text-black border-r'>{d?.company_name} </h6>
                <h6 className='text-[12px] truncate w-[200px] min-w-[200px] md:w-[15%] md:min-w-[15%] px-2 py-1  opacity-70 text-black border-r'>{d?.address}</h6>
                <h6 className='text-[12px] truncate w-[100px] min-w-[100px] md:w-[10%] md:min-w-[10%] capitalize  px-2 py-1  opacity-70 text-black border-r'>{(d?.client_type !== '' && d?.client_type !== null && d?.client_type !== undefined) && <span className='bg-blue-300 text-[10px] px-[4px] py-[4px] rounded font-[700] '>{d?.client_type}</span>}</h6>
                <h6 className='text-[12px] truncate w-[200px] min-w-[200px] md:w-[15%] md:min-w-[15%] px-2 py-1  opacity-70 text-black border-r'>{d?.comments}</h6>
                <h6 className='text-[12px] flex truncate w-[90px] min-w-[90px] md:w-[6%] md:min-w-[6%]  px-2 py-1  opacity-70 text-black '>
                  <AiOutlineEdit className='mr-2' onClick={()=>{navigate('edit',{state:d})}} />
                  {['admin','Admin']?.filter((f)=>roles?.includes(f))?.length > 0 &&
                  <AiOutlineDelete onClick={()=>{setselecteddata(d);setmodal(true)}} />}
                </h6>
            </div>))}
          </div>}
       </div>
       
    </div>
  )
}

export default ClientList